// #region License

/**
 * @license
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

// #endregion

//biome-ignore lint/style/useImportType: this is usefulle
import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const LauncherIcon = () => /*#__PURE__*/_jsxs("svg", {
  width: "22",
  height: "22",
  viewBox: "0 0 22 22",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  "data-sentry-element": "svg",
  "data-sentry-component": "LauncherIcon",
  "data-sentry-source-file": "Launcher.tsx",
  children: [/*#__PURE__*/_jsx("title", {
    children: "Launcher"
  }), /*#__PURE__*/_jsx("rect", {
    width: "6",
    height: "6",
    fill: "currentColor",
    "data-sentry-element": "rect",
    "data-sentry-source-file": "Launcher.tsx"
  }), /*#__PURE__*/_jsx("rect", {
    x: "8",
    width: "6",
    height: "6",
    fill: "currentColor",
    "data-sentry-element": "rect",
    "data-sentry-source-file": "Launcher.tsx"
  }), /*#__PURE__*/_jsx("rect", {
    x: "16",
    width: "6",
    height: "6",
    fill: "currentColor",
    "data-sentry-element": "rect",
    "data-sentry-source-file": "Launcher.tsx"
  }), /*#__PURE__*/_jsx("rect", {
    y: "8",
    width: "6",
    height: "6",
    fill: "currentColor",
    "data-sentry-element": "rect",
    "data-sentry-source-file": "Launcher.tsx"
  }), /*#__PURE__*/_jsx("rect", {
    x: "8",
    y: "8",
    width: "6",
    height: "6",
    fill: "currentColor",
    "data-sentry-element": "rect",
    "data-sentry-source-file": "Launcher.tsx"
  }), /*#__PURE__*/_jsx("rect", {
    x: "16",
    y: "8",
    width: "6",
    height: "6",
    fill: "currentColor",
    "data-sentry-element": "rect",
    "data-sentry-source-file": "Launcher.tsx"
  }), /*#__PURE__*/_jsx("rect", {
    y: "16",
    width: "6",
    height: "6",
    fill: "currentColor",
    "data-sentry-element": "rect",
    "data-sentry-source-file": "Launcher.tsx"
  }), /*#__PURE__*/_jsx("rect", {
    x: "8",
    y: "16",
    width: "6",
    height: "6",
    fill: "currentColor",
    "data-sentry-element": "rect",
    "data-sentry-source-file": "Launcher.tsx"
  }), /*#__PURE__*/_jsx("rect", {
    x: "16",
    y: "16",
    width: "6",
    height: "6",
    fill: "currentColor",
    "data-sentry-element": "rect",
    "data-sentry-source-file": "Launcher.tsx"
  })]
});